import IMG7 from "./db-img/molema.jpeg";
import IMG8 from "./db-img/dami.jpeg";
import IMG9 from "./db-img/abdel.png";
import IMG10 from "./db-img/shams.jpeg";
import IMG11 from "./db-img/alan.png";
import IMG12 from "./db-img/nic.png";
import IMG13 from "./db-img/vic.png";
import IMG14 from "./db-img/rahman.jpeg";
import IMG15 from "./db-img/kenny.jpeg";

const recommendation = [
  {
    id: 1,
    text: "I worked together with Elizabeth at TIIDELab and I can say Elizabeth is very goal oriented as well as a team player, she demonstrated to be an exceptional software engineer, well organized and thrived under pressure.",
    image: IMG8,
    name: "Damilola Ogungbenro",
    location: "Ottawa, Canada",
  },
  {
    id: 2,
    text: "While at TIIDELAB Initiative  Abuja Nigeria, I saw that Elizabeth is an energetic individual and is skilled in her field. always willing to improve she will be a valuable asset to your organisation.",
    image: IMG7,
    name: "Molema Lema",
    location: "Dubai, UAE",
  },
  {
    id: 3,
    text: "Elizabeth has strong problem-solving skills as well as excellent communication skills which are complementary to making her a great remote software developer. Any company that loves balance in project delivery would be happy to have her on their team.",
    image: IMG9,
    name: "Abdelmejid Oumer Ali",
    location: "Addis Abbaba, Ethiopia",
  },
  {
    id: 4,
    text: "Elizabeth’s willingness to go above and beyond while executing a task is worthy of emulation. Her dexterity, poise, energy and resourcefulness in and out of her role as a fellow with us is admirable. Put her behind a system to code,or before her peers to solve problems, she will do just fine",
    image: IMG10,
    name: "Shamsudeen Aderoju",
    location: "Abuja, Nigeria",
  },
  {
    id: 5,
    text: "It’s my pleasure to recommend Elizabeth, she is smart and has strong personality, she is able to solve urgent problems with minimum periods, she is fit to work in a team and collaboration both in site or remote.",
    image: IMG11,
    name: "Alan Lukman",
    location: "Slemani, Iraqi",
  },
  {
    id: 6,
    text: "I highly recommend Elizabeth as a Software Developer and would love to work together again with her. Elizabeth is amazing at her job! she knows her way around people, she is good with the students and colleagues, does whatever it takes to help colleagues, and gets things done.",
    image: IMG12,
    name: "Nicholas Chimaobi Emmanuel",
    location: "Lagos, Nigeria",
  },
  {
    id: 7,
    text: "Elizabeth is one of the smartest software developers I’ve ever met.During the time we worked together she showed commitment and determination towards team building.She is a person who has exceptional leadership skills and has used that skill to impact those around her and the success of the team.",
    image: IMG13,
    name: "Victor Okoroji",
    location: "Lagos, Nigeria",
  },
  {
    id: 8,
    text: "Elizabeth is one of the best and most courageous person I’ve ever met; I’ve had the opportunity to work with her several times and found her to be a great collaborator. She’s relentless on any task she decides to work on. I strongly recommend her for any organization because I have strong faith in her abilities.",
    image: IMG14,
    name: "Rahman",
    location: "Lagos Nigeria",
  },
  {
    id: 8,
    text: "Elizabeth is one of the brightest software developers I’ve ever met. I worked alongside her at TiideLab where she was instrumental in building amazing projects. Elizabeth is always challenging herself-- her attention to detail is evident in all of the projects I’ve worked with her on. She’s also genuinely kind.",
    image: IMG15,
    name: "Kehinde Onifade",
    location: "Osun, Nigeria",
  },
];

export default recommendation;
